<script setup>
import { computed } from 'vue';
import {
    formataCpf,
    formataCnpj,
    formataDataFromDb,
    formataMoedaReais
} from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

const pessoafisica = import.meta.env.VITE_TIPO_PESSOA_FISICA;

// A descrição pode vir como uma string normal ou como uma lista ([ ]),
// seja um array real ou uma string contendo um array. Normaliza ambos.
const descricaoFormatada = computed(() => {
    let valor = props.solicitacao?.dados?.descricao;
    if (valor == null) return '';

    if (typeof valor === 'string') {
        const texto = valor.trim();
        if (texto.startsWith('[') && texto.endsWith(']')) {
            try {
                valor = JSON.parse(texto);
            } catch {
                return valor;
            }
        } else {
            return valor;
        }
    }

    if (Array.isArray(valor)) {
        return valor
            .filter((item) => item != null && String(item).trim() !== '')
            .join('<br>');
    }

    return String(valor);
});
</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Beneficiário" :conteudo="solicitacao.dados.pessoa_nome" :detalhe="pessoafisica ==
        solicitacao.dados.tipo_pessoa ? 'CPF: ' +
    formataCpf(solicitacao.dados.pessoa_documento, false) : 'CNPJ: ' +
    formataCnpj(solicitacao.dados.pessoa_documento, false)" />

    <LabelDados titulo="Valor" :conteudo="formataMoedaReais(solicitacao.dados.valor)" />

    <LabelDados titulo="Data da Compra" :conteudo="formataDataFromDb(solicitacao.dados.data_compra)" />

    <LabelDados titulo="Justificativa" :conteudo="solicitacao.dados.justificativa" tamanho_div="col-12" />

    <LabelDados titulo="Descrição" tamanho_div="col-12">
        <template #conteudo>
            <div v-html="descricaoFormatada" class="text-900 text-sm font-semibold"></div>
        </template>
    </LabelDados>

    <hr class="w-full border-solid border-top-1 border-bottom-none surface-border my-3"
        v-if="solicitacao.dados.tem_boleto">

    <h3 class="text-900 font-bold text-sm mb-3 col-12" v-if="solicitacao.dados.tem_boleto">Informações do Boleto</h3>

    <LabelDados v-if="solicitacao.dados.tem_boleto" titulo="Valor"
        :conteudo="`${formataMoedaReais(solicitacao.dados.boleto_valor)} - Data de vencimento: ${formataDataFromDb(solicitacao.dados.boleto_data_vencimento)}`"
        detalhe="Esta solicitação será paga via boleto bancário" tamanho_div="col-12" />
</template>